import styled from 'styled-components';

export default styled.div`
  position: relative;
  max-width: 205px;
  margin: auto;

  .avatar-edit {
    position: absolute;
    right: 5px;
    z-index: 1;
    bottom: 0px;

    input {
      display: none;
      + label {
        display: inline-block;
        width: 32px;
        height: 32px;
        margin-bottom: 0;
        border-radius: 100%;
        background: #ffffff;
        border: 1px solid transparent;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
        cursor: pointer;
        text-align: center;
        font-weight: normal;
        transition: all 0.2s ease-in-out;
        color: '#828894';
        padding: 5px;
        &:hover {
          background: #f1f1f1;
          border-color: #d6d6d6;
        }
      }
    }
  }

  .avatar-preview {
    width: 120px;
    height: 120px;
    position: relative;
    border-radius: 100%;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);

    > div {
      width: 100%;
      height: 100%;
      border-radius: 100%;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
`;
